import React from "react";
import { Navigate } from "react-router-dom";

const getUser = () => {
  const raw = localStorage.getItem("user") || localStorage.getItem("authUser");
  try { return raw ? JSON.parse(raw) : null; } catch { return null; }
};

export default function RequireRole({ roles = [], children }) {
  const u = getUser();
  if (!u) return <Navigate to="/login" replace />;

  const role = u?.role;
  if (roles.length > 0 && !roles.includes(role)) return <Navigate to="/dashboard" replace />;

  return children;
}
